import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { observer } from 'mobx-react';

import { BooleanView } from 'src/core/ui/boolean.view';
import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { ZuluIcon } from 'src/app/shared/icon';

interface SellMarginPolicyViewProps extends ComponentViewProps<DataSet<SellMarginPolicySummary>> {
	mode: ControlMode;
	canSave: boolean;
	onModeChange: (mode: ControlMode) => void;
	onSave: () => void;
	onItemDoubleClicked: (item?: SellMarginPolicySummary) => any;
	swapDownPriorities: (index: number) => void;
	resetPriorities: () => void;
}

@observer
export class SellMarginPolicyListView extends React.Component<SellMarginPolicyViewProps, {}> {
	render(): React.ReactNode {
		const { model, mode, canSave, onModeChange, onSave, onItemDoubleClicked, swapDownPriorities, resetPriorities, setBusy } = this.props;
		const columns: Column[] = [
			{
				title: '',
				key: 'index',
				width: '20px',
				render: (text, record, index) => {
					return (
						<div>
							{
								index > 0 &&
								<div>
									<Button
										disabled={mode === 'display'}
										size="small"
										onClick={() => swapDownPriorities(index)}
									>
										<ZuluIcon type="caret-up" />
									</Button>
								</div>
							}
							{
								index < (model.count - 1) &&
								<div>
									<Button
										disabled={mode === 'display'}
										size="small"
										onClick={() => swapDownPriorities(index + 1)}
									>
										<ZuluIcon type="caret-down" />
									</Button>
								</div>
							}
						</div>
					);
				}
			},
			{
				key: 'priority',
				title: 'Priority',
				dataIndex: 'priority'
			},
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: SellMarginPolicySummary) => <Link to={`/bookings/sell-margin-policies/${record.id}`}>{text}</Link>
			},
			{
				key: 'margin',
				title: 'Margin',
				dataIndex: 'margin',
				render: (value) => `${value * 100}%`
			},
			{
				key: 'isActive',
				title: 'Is Active',
				dataIndex: 'isActive',
				render: (text, record) => (
					<BooleanView
						mode="display"
						value={record.isActive}
					/>
				)
			}
		];
		
		const menuItems: any[] = [
			{
				key: 'save',
				icon: 'save',
				disabled: !canSave,
				name: 'Save Priority Order',
				onClick: () => onSave()
			},
			{
				key: 'reset',
				icon: 'reset',
				disabled: mode === 'display',
				name: 'Reset Priorities',
				onClick: () => resetPriorities()
			}
		];

		if (mode === 'display') {
			menuItems.push({
				key: 'edit',
				icon: 'edit',
				name: 'Edit Priorities',
				onClick: () => onModeChange('edit')
			});
		} else {
			menuItems.push(
				{
					key: 'close',
					icon: 'close',
					name: 'Close',
					onClick: () => onModeChange('display')
				}
			);
		}

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={columns}
						setBusy={setBusy}
						itemDoubleClick={onItemDoubleClicked}
						toolbarLeftItems={menuItems}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/sell-margin-policies/list/sell-margin-policy-list.view.tsx